var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-select",
    _vm._g(
      _vm._b(
        {
          ref: "selectRef",
          staticStyle: { width: "100%" },
          attrs: {
            value: _vm.newValue,
            placeholder: _vm.placeholder,
            filterable: _vm.filterable,
            clearable: _vm.clearable,
            "remote-method": _vm.remoteMethods,
            disabled: _vm.disabled,
            loading: _vm.loading || _vm.$attrs.loading,
          },
        },
        "el-select",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    _vm._l(_vm.options, function (item) {
      return _c(
        "el-option",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !item.hide,
              expression: "!item.hide",
            },
          ],
          key: item.value,
          style: item.color ? { background: item.color, color: "#ffffff" } : {},
          attrs: {
            label: item.label,
            value: item.value,
            disabled: !!item.disabled,
          },
        },
        [_vm._t("default", null, { item: item })],
        2
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }